<template>
  <!-- eslint-disable max-len -->
  <div class="root">
    <div class="content">
      <div class="login-card">
        <div class="login-card-background" />
        <div class="login-form-container">
          <div>
            <span v-if="verifyEmailSuccess">
              Email verified!
              <router-link to="/signin" style="color: rgb(80, 80, 80);">Click here to login.</router-link>
            </span>
            <span v-else-if="verifying" style="display: flex; flex-direction: row; align-items: center;">
              <blade-spinner use-bootstrap-size no-background style="margin-right: 10px;">
                <span class="sr-only">Please wait...</span>
              </blade-spinner>
              <span>Verifying email...</span>
            </span>
            <span v-else>
              Email verification failed. If refreshing the page doesn't resolve the problem, contact support via the help link in the top right.
            </span>
          </div>
        </div>
      </div>
      <div class="login-card">
        <div class="login-card-background" :style="brandBackgroundStyle" />
        <div class="login-brand-container">
          <div class="brand-top">
            <div class="brand-image" :style="`background-image: url('${brandImage}');`" />
          </div>
          <div style="border: 1px solid white;"/>
          <div class="brand-bottom" v-html="brandText"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import catalogPurchaseTarget from '../../utils/catalog';

export default {
  data() {
    return {
      verifying: false,
      verifyEmailSuccess: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeSignInConfig',
      'me'
    ]),
    brandBackgroundStyle() {
      return {
        'background-color': this.activeSignInConfig.brandPrimaryColor
      };
    },
    brandImage() {
      return this.resolveAssetPath(this.activeSignInConfig.midsectionImage, 'ui/customer');
    },
    brandText() {
      return this.activeSignInConfig.midsectionText || 'RedmerU is a hosting platform for digital case studies also known as “gamulations” for academic use in higher education institutions. These applications provide an experiential learning experience for college students both in the classroom and from home in a distance learning environment.';
    }
  },
  methods: {
    ...mapActions([
      'verifyEmail',
      'renewAuthToken',
      'flashDanger'
    ]),

    async dispatchVerifyEmail() {
      if (this.verifying) return;
      this.verifying = true;

      try {
        const code = this.$route.params.code;
        // The verify endpoint issues a fresh auth token (x-auth) which the
        // axios interceptor stores automatically.
        await this.verifyEmail({ code });
        // Refresh `me` so it includes the (now populated) registration link
        // and its catalog, then decide whether to route to the content catalog
        // purchase page or show the verification success message.
        await this.renewAuthToken();
        const target = await catalogPurchaseTarget(this.$store, this.me);
        if (target) {
          this.verifying = false;
          this.$router.replace(target);
          return;
        }
        this.verifyEmailSuccess = true;
        this.verifying = false;
      } catch (err) {
        console.error(err);
        const message = 'Email verification was unsuccessful';
        this.flashDanger({ message });
        this.verifying = false;
      }
    }
  },
  mounted() {
    this.dispatchVerifyEmail();
  }
};
</script>

<style lang="scss" scoped>
.loader {
  border: 4px solid #f3f3f3aa;
  border-top: 4px solid #4448baaa;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: auto;
  animation: spin .75s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.root {
  // 40px == the navbar height.  If that changes, change this.
  height: calc(100vh - 40px);
  background-size: cover;
  width: 100%;
  position: relative;
  // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 100;
}

.content {
  input {
    color: rgb(34, 34, 34);
  }
  // color: var(--signInTextColor);
  color: rgb(34,34,34);
  display: flex;
  flex-direction: row;
  justify-content: center;

  height: 45%;
  width: 100%;
  padding-left: 22%;
  padding-right: 22%;
  position: absolute;
  top: 15%;
}

.login-card {
  position: relative;
  min-width: 400px;
  min-height: 500px;
  margin: 10px;
  width: 30%;
  height: 100%;
  border-radius: 15px;
  border: 2px solid white;
  overflow: hidden;
}

.login-card-background {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;

  background-color: white;
  mask-image: url('/static/ui/customer/EA1_loginBox-White.png');
  mask-size: 110% 110%;
  mask-position: center;
}

.login-form-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
  overflow-y: auto;
}

.login-form-footer
{
  display: flex;
  justify-content: space-between;
}

.login-form-login-button-container
{
  display: flex;
  justify-content: flex-end;
}

.login-brand-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px;
  overflow-y: auto;
  color: white;
}

.brand-top
{
  height: 48%;
}

.brand-bottom
{
  height: 48%;
  font-size: 18px;
}

.brand-image
{
  position: relative;
  width: 100%;
  height: 100%;
  padding: 30px;
  background-origin: content-box;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.lgn-lg-btn
{
  font-size: 18px;
  min-width: 100px;
  height: 40px;
  padding: 5px;
}

.login-title
{
  font-size: 30px;
  text-transform: uppercase;
  font-weight: 50;
}

.form-element
{
  margin: 5px;
}

.error-container
{
  margin-top: 5px;
  height: 20px;
}

.error-msg
{
  color: darkred;
  font-weight: 500;
}

.brand-bottom
{
  color: var(--signInTextColor);
}

.eula-prompt-container
{
  position: fixed;
  top: calc(20vh - 15px);
}
</style>



// WEBPACK FOOTER //
// src/components/auth/VerifyEmail.vue